import React from 'react';
import Checkbox from '../webcommon/common/checkbox/Checkbox';


const mappings = [
    {
        id: 'id',
        title: 'ResultId'
    },
    {
        id: 'checkbox',
        title: 'Export',
        width: 40,
        filterable: false,
        renderCell: row => (
            <Checkbox
                checked={ row.original.selected }
                onChange={ (checked) => {
                    row.column.getGridProps().setRowChecked(row.original.id, checked);
                } }
            />
        ),
        Header: header => (
            <Checkbox
                checked={ header.column.getGridProps().headerChecked }
                onChange={ (checked) => {
                    header.column.getGridProps().setHeaderChecked(checked);
                } }
            />
        )
    }
];

export default mappings;
